// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2be564aa","455":"b7fb80eb","977":"6e42f3c6"}[chunkId] + ".chunk.js";
};